import React, { Component } from 'react'
import './noplate.css'
import Toggle from './toggle/toggle'
import { fire } from '../../config/firebase'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Social from '../front/social/social'

export default class NoPlate extends Component {
    state={
toggle:true,days:['Domingo','Segunda-feira','Terca','Quarta-feira','Quinta-feira','Sexta-feira','Sabado']
,routine_array:[{Thursday:{Ida:false,Volta:true}}], driver_Not_found : false,driver_found:false,finding_driver:true
    }
   async componentDidMount(){
        let {days} = this.state;

        let user = JSON.parse(localStorage.getItem('user'))
        if(user){

            // ____________shift__________________//
            let _shift_ = fire.firestore().collection('userRegistration')
           _shift_.onSnapshot(__shift =>{
               __shift.forEach(__s=>{
                   if(user.uid === __s.id){
                       this.setState({
                           __shift__:__s.data().shift
                       })
                   }
               })
           })

            // _____________end__________________//

            try {
                let user_ = await fire.firestore().collection('userRegistration').doc(user.uid)
            var data =user_.collection('routine');
            data.onSnapshot(snap=>{
                let routine_array = [];
                snap.forEach(val=>{
                    console.log('val___+_',val.id,val.data())
                    // let t = new Date().getDay(val.id)

 //LOCATION_UPDATING_________________.....
 

  navigator.geolocation.getCurrentPosition((location) => {
    user_.update({location:{lat:location.coords.latitude ,lng:location.coords.longitude}})
      // location.coords.latitude
      // location.coords.longitude
  });
  //......______________________________END..


                    routine_array.push({[val.id]:val.data()} )
                    localStorage.setItem('routine_array',JSON.stringify({routine_array}))
                })
                this.setState({routine_array})
            })
        }catch (error) {
            alert(error.message)
        }
        
        var days_to_render = [];
        let date = new Date().getDate();
        for(let i = 0; i<7;i++){
            let d = new Date().setDate(date + i)
            let dat = new Date(d).getDate();
            let din=new Date(d).getDay();
            let month=new Date(d).getMonth();
            let year = new Date(d).getFullYear();
            days_to_render.push({date:dat,day:days[din],month,year});
            console.log('**************||||||*********',days_to_render)
        }

        this.setState({
            days_to_render
        })
        
        
        //________________________________CHECKING_FOR_VAN_________________________________________//
        let driver_exist = false;
        var check = false
        let user_plate = fire.firestore().collection('userRegistration');
        let van_plate = fire.firestore().collection('vanRegistration');
        await user_plate.onSnapshot(plate=>{
            plate.forEach(pl=>{
              if(pl.id === user.uid ){
                  van_plate.onSnapshot(snap=>{
                      snap.forEach(val=>{
                          check=true
            if(val.data().placa === pl.data().vanPlate){
                console.log('congratulation',val.data().placa,'_________',val.id)
               driver_exist=true;
               this.setState({
                   driver_found:val.data(),
                   driver_Not_found:false,
                   finding_driver:false,
               })
            }
            console.log('vamn_plate',val.data())
        })
    })
    
}

            })
        })
        setTimeout(()=>{
            if(!driver_exist && check){
                console.log('******************',check)
                
                // alert('Driver not found please ask your driver to registerd here..')
                this.setState({
                    driver_found:false,
                    driver_Not_found:true,
                    finding_driver:false,
                })
                
            }
        },3000)
        if(!check )
        setTimeout(()=>{
            if(!check){
                // alert('No Internet available')
                }
            },4000)
            //______________________________END_CHECKING_VAN____________________________________________//

            
            

            
            let da_ = localStorage.getItem('user');
            if(data){
                let user = JSON.parse(da_);
                console.log('user>',user)
                this.setState({
                    name:user.name,
                    uid:user.uid
                })
            }
            fire.firestore().collection('userRegistration').onSnapshot(snap=>{
                snap.forEach(plate=>{
                    console.log('plate_____________',plate)
                })
            })
        }
        else{
            alert('Please login First...')
            this.props.props.push('/')
        }
        }
        routineHandler(y,day,date,month,year,way){
            let user = JSON.parse(localStorage.getItem('user'))
            // alert(y+day+date+'-'+month+"-"+year+way)
            fire.firestore().collection('userRegistration').doc(user.uid).collection('routine').doc(day).update({[way]:y})
            
    }
    routine(){
        let user = JSON.parse(localStorage.getItem('user'))
        let data = fire.firestore().collection('userRegistration').doc(user.uid).collection('routine');
        fire.firestore().collection('userRegistration').doc(user.uid).collection('routine').doc('29-8-2019').set({ida:false,volta:false})
       data.onSnapshot(snap=>{
           snap.forEach(val=>{
               console.log('val___+_',val.id,val.data())
           })
       })
    }
    _logout(){
        fire.auth().signOut().then(s=>{
            alert('logout com sucesso')
            localStorage.removeItem('user')
            this.props.props.push('/')
        }).catch(e=>{
            alert(e.message)
        })
    }
    render() {
        AOS.init({duration:1000})
        // this.routine();
        console.log('days_to_render',this.state.days_to_render)
        let{
            name,
            days_to_render,
            routine_array,
            driver_Not_found,
            driver_found,
            finding_driver,
            __shift__,
        } = this.state
        console.log('routine_array>>___',routine_array)
        return (
            <div className='main'>
                <div className='nn_header'>
                    <h1>Arriba!</h1>
                </div>
               <Social/>

                {finding_driver &&
                <div className='nnn_body'>
                <h1>Parabéns!</h1>
                    <h3>{name}</h3>
                    <p>Estamos encontrando sua van usando a placa van fornecida por você..</p>
                <div className="loader"></div> 
                </div>
                }

                {driver_Not_found &&
                <div>
  <div className='cmt'>
                    <button onClick={()=>this.props.props.push('/user/userRoutine/profile')} >Perfil</button>
                       {/* <button onClick={()=>this.props.props.push('/user/userRoutine/comment')}>Comment</button> */}
                       <button onClick={()=>this._logout()}>Sair</button>
                    </div>
                <div className='nnn_body' >
                    
                    <h1>Sorry!</h1>
                    <h3>{name}</h3>
                    <p>Your Van is not registerd. Please ask your van owner to registerd here for free.Thanks</p>
                {/* <div className="loader"></div> */}

                </div>
                </div>
                }

                    {driver_found &&
                <div className='n_body'>

                    <div className='cmt'>
                    <button onClick={()=>this.props.props.push('/user/userRoutine/profile')} >Perfil</button>
                       {/* <button onClick={()=>this.props.props.push('/user/userRoutine/comment')}>Comment</button> */}
                       <button onClick={()=>this._logout()}>Sair</button>
                    </div>

                   
                    <div className='van_driver'>
                        <p>{__shift__+' Van'}</p>
                        <div className='driver_detail'>
                            <img src={driver_found.photo} alt={driver_found.name}/>
                            <div>
                                <p>{driver_found.name}</p>
                                <p>{"modelo : "+driver_found.modelo}</p>
                                <p>{"Placa : "+driver_found.placa}</p>
                            </div>
                        </div>
                    </div>


                    {/* days______ */}
                    { days_to_render && days_to_render.map((day,key)=>{
                        
                        return(
                            
                            <div key={key} className='days_main' data-aos='fade-up'>
                        <div className='days_header'>
                        <h2>{day.day}</h2>
                        </div>
                        <div className='days_body'>
                        <h2>{day.date}</h2>
                        {
                               routine_array && routine_array.map((value) => {
                                   let df = day.day
                                    console.log('++++++++++++',value[df],df)
                                    if(value[df]){
                                        
                                        return(
                                            
                                            <div className='toggle'>
                                            <div style={{display:'flex'}}>
                                            <h3> Ida ..</h3>
                                            <Toggle func={this.routineHandler} val = {value[df]&&value[df].Ida} day={day.day} month={day.month} year={day.year} date={day.date} way={'Ida'}/>
                                </div>
                                
                                <div style={{display:'flex'}}>
                                <h3>volta</h3>
                                <Toggle
                                val = {value[df]&&value[df].Volta}
                                func={this.routineHandler} day={day.day} month={day.month} year={day.year} date={day.date} way={'Volta'}
                                />
                                </div>
                                </div>
                                )
                            }
                        })
                    }
                    </div>
                    </div>
                    
                    )
                })}
                
                {/* end_________ */}
                
                
                
                </div>
            }
                <div className='n_footer'>
                    <h3>Thank you for using Arriba!</h3>
                </div>
            </div>
        )
    }
}
